// src/redux/actions/jobTypeActions.js
import {
    FETCH_DESIGNATION_REQUEST,
    FETCH_DESIGNATION_SUCCESS,
    FETCH_DESIGNATION_FAILURE,
    SET_SELECTED_DESIGNATION,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchDesignation = () => async (dispatch) => {
    dispatch({ type: FETCH_DESIGNATION_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetDesignationsDDL`);
      let designationList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
          
        }
    })
      dispatch({
        type: FETCH_DESIGNATION_SUCCESS,
        payload: designationList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_DESIGNATION_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectDesignation = (designationId) => ({
    type: SET_SELECTED_DESIGNATION,
    payload: designationId,
  });
  